var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1818 3H13.6364C13.1846 3 12.8182 3.36426 12.8182 3.81357C12.8182 4.26288 13.1846 4.62714 13.6364 4.62714H18.2066L9.78523 13.001C9.4657 13.3188 9.4657 13.8338 9.78523 14.1516C9.94495 14.3104 10.1543 14.3898 10.3637 14.3898C10.5731 14.3898 10.7825 14.3104 10.9423 14.1515L19.3636 5.77766V10.3221C19.3636 10.7714 19.73 11.1356 20.1818 11.1356C20.6337 11.1356 21 10.7714 21 10.3221V3.81357C21 3.36426 20.6336 3 20.1818 3Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9089 11.2373C16.457 11.2373 16.0907 11.6015 16.0907 12.0508V19.3729H4.63633V7.98304H11.9999C12.4517 7.98304 12.8181 7.61878 12.8181 7.16947C12.8181 6.72016 12.4517 6.35593 11.9999 6.35593H3.81818C3.36632 6.35593 3 6.72019 3 7.1695V20.1865C3 20.6357 3.36632 21 3.81818 21H16.9089C17.3608 21 17.7271 20.6357 17.7271 20.1864V12.0508C17.7271 11.6015 17.3608 11.2373 16.9089 11.2373Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c089541e28395d7f4fb0a323b1ac9c7a.svg";
export { ForwardRef as ReactComponent };